import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Sidebar from "src/components/common/Sidebar";
import {
  useAppEventGameListSelector,
  useAppPerformanceListSelector,
  useAppRodeoEventSettingsSelector,
} from "src/_common/hooks/selectors/eventSelector";
// import { useAppPerformanceInfoSelector, useAppPerformanceListSelector, useAppRodeoEventSettingsSelector } from "src/_common/hooks/selectors/eventSelector";
import { CRYPTO_SECRET_KEY, RODEO_PAGE_NAME, URLS } from "src/_config";
import Sponsor from "src/components/common/Sponsor";
import moment from "moment";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function PrizesListPage() {
  const history = useHistory();
  const { eventId, performanceId } = useParams<any>();
  const rodeoEventSettings = useAppRodeoEventSettingsSelector();
  const types = ["Game", "Event", "Performance"];
  const performanceList = useAppPerformanceListSelector();

  const gotoPrizeDetailsPage = (type: any) => {
    history.push(`/prize/${eventId}/${performanceId}/${cryptr.encrypt(type)}`);
  };

  const gotoEventPage = () => {
    history.push(`/event/${eventId}/${performanceId}`);
  };

  const gotoPerformancesPage = () => {
    history.push(`/performances/${eventId}`);
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <React.Fragment>
      <div className="main-content-panel">
        <div className="d-flex justify-content-between align-items-center team-list-title-panel gap-3">
          <div className="team-list-title">
            <h1>{performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.title}</h1>
          </div>
          <div className="team-list-date">
            <p>
              {performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.pdate
                ? moment(performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.pdate).format(
                    "MMM DD, YYYY"
                  )
                : ""}
            </p>
          </div>
        </div>
        <h1>Prizes</h1>
        <ul className="list-style rodeo-inside-list mt-4">
          {types.map((type: any, i: any) =>
            rodeoEventSettings["is_" + type.toLowerCase() + "_prize"] ? (
              <li key={i}>
                <a className={"d-flex gap-3 mb-3"} onClick={() => gotoPrizeDetailsPage(type)}>
                  <span>
                    <i
                      className={
                        type == "Game" ? "fas fa-trophy" : type == "Performance" ? "fa fa-shield" : "fa fa-flag"
                      }
                      style={{ fontSize: "25px", color: "#fff" }}
                    />
                  </span>
                  <span className="event-info">
                    <span style={{ color: "#fff" }} className="d-inline-block event-title">
                      {type} Prize
                    </span>
                  </span>
                </a>
              </li>
            ) : null
          )}
        </ul>
        <div className="join-now-btn-wrap">
          <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={gotoEventPage}>
            Play Now
          </button>
        </div>
      </div>
      <Sponsor />
    </React.Fragment>
  );
}
